import { CALL_API, Schemas } from '../../common/middleware/api';

export const PRICES_REQUEST = 'PRICES_REQUEST';
export const PRICES_SUCCESS = 'PRICES_SUCCESS';
export const PRICES_FAILURE = 'PRICES_FAILURE';

export const PRICE_FETCH_REQUEST = 'PRICE_GET_REQUEST';
export const PRICE_FETCH_SUCCESS = 'PRICE_GET_SUCCESS';
export const PRICE_FETCH_FAILURE = 'PRICE_GET_FAILURE';

export const PRICE_CREATE_REQUEST = 'PRICE_CREATE_REQUEST';
export const PRICE_CREATE_SUCCESS = 'PRICE_CREATE_SUCCESS';
export const PRICE_CREATE_FAILURE = 'PRICE_CREATE_FAILURE';

export const PRICE_UPDATE_REQUEST = 'PRICE_UPDATE_REQUEST';
export const PRICE_UPDATE_SUCCESS = 'PRICE_UPDATE_SUCCESS';
export const PRICE_UPDATE_FAILURE = 'PRICE_UPDATE_FAILURE';

export const loadPrices = (options) => ({
	[CALL_API]: {
		types: [PRICES_REQUEST, PRICES_SUCCESS, PRICES_FAILURE],
		endpoint: 'api/prices',
		request: options,
		schema: Schemas.PRICE_ARRAY
	}
});

export const fetchPrice = (id) => ({
	[CALL_API]: {
		types: [PRICE_FETCH_REQUEST, PRICE_FETCH_SUCCESS, PRICE_FETCH_FAILURE],
		endpoint: `api/prices/${id}`,
		schema: Schemas.PRICE
	}
});

export const createPrice = (price, history) => ({
	[CALL_API]: {
		types: [PRICE_CREATE_REQUEST, PRICE_CREATE_SUCCESS, PRICE_CREATE_FAILURE],
		endpoint: 'api/prices',
		method: 'POST',
		request: price,
		schema: Schemas.PRICE,
		form: 'price',
		transition: {
			history,
			successPath: (response) => {
				return `/prices`;
			}
		}
	}
});

export const updatePrice = (id, price) => ({
	[CALL_API]: {
		types: [PRICE_UPDATE_REQUEST, PRICE_UPDATE_SUCCESS, PRICE_UPDATE_FAILURE],
		endpoint: `api/prices/${id}`,
		method: 'PUT',
		request: price,
		schema: Schemas.PRICE,
		form: 'price'
	}
});